// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDatePicker-Underlay_cls1__aNdRU","cls2":"VeloDatePicker-Underlay_cls2__q4yPq VeloDatePicker-Underlay_cls1__aNdRU"};